import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
import { getOptionList, optionKey } from "@/api/api-dict";
let PiHomeMmapScreenOther = class PiHomeMmapScreenOther extends Vue {
    constructor() {
        super(...arguments);
        this.poptipVisible = false;
        this.all = false;
        this.netDirectionList = [];
        this.staStatusList = [];
        this.staActivity = [
            { itemKey: "1", itemValue: i18n.t("homeMap.yes") },
            { itemKey: "2", itemValue: i18n.t("homeMap.no") },
        ];
        this.nameText = "";
        this.checkList = [
            {
                name: i18n.t("homeMap.netDirection"),
                all: false,
                key: "netDirectionList",
                list: this.netDirectionList,
            },
            {
                name: i18n.t("homeMap.staStatus"),
                all: false,
                key: "staStatusList",
                list: this.staStatusList,
            },
            {
                name: i18n.t("homeMap.staActivity"),
                all: false,
                key: "staActivity",
                list: this.staActivity,
            },
        ];
        this.formInline = {
            netDirectionList: [],
            staActivity: [],
            staStatusList: [],
            pileNumMaxValue: "",
            pileNumMinValue: "",
            powerMaxValue: "",
            powerMinValue: "",
        };
    }
    /**
     * 重置
     */
    resetting() {
        this.formInline.netDirectionList = [];
        this.formInline.staActivity = [];
        this.formInline.staStatusList = [];
        this.formInline.pileNumMaxValue = "";
        this.formInline.pileNumMinValue = "";
        this.formInline.powerMaxValue = "";
        this.formInline.powerMinValue = "";
        this.nameText = "";
    }
    /**
     * 全选
     */
    cllChange(val, key) {
        if (!val) {
            this.formInline[key] = [];
        }
        else {
            let list = this[key] || [];
            this.formInline[key] = list.map((item) => {
                return item.itemKey;
            });
        }
    }
    /**
     * 字典查询
     */
    async getOptionList() {
        const data = await getOptionList([
            optionKey.netDriectionObj,
            optionKey.staStatusObj,
        ]);
        this.netDirectionList = data[optionKey.netDriectionObj];
        this.staStatusList = data[optionKey.staStatusObj];
        this.netDirectionList.push({
            itemValue: i18n.t("homeMap.notOpened"),
            itemKey: "3",
        });
        this.checkList[0].list = this.netDirectionList;
        this.checkList[1].list = this.staStatusList;
    }
    /**
     * 返回数据
     */
    retureData() {
        this.poptipVisible = false;
        this.nameText = this.forCityName();
        this.$emit("change", {
            ...this.formInline,
        });
    }
    /**
     * 找出是否有选择
     */
    forCityName() {
        let name = [];
        for (let i in this.formInline) {
            let item = this.formInline[i];
            if (typeof item == "string" && item != "") {
                name.push(i);
            }
            if (typeof item == "object" && item.length != 0) {
                name.push(i);
            }
        }
        return name.join("/");
    }
    mounted() {
        this.getOptionList();
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeMmapScreenOther.prototype, "searchName", void 0);
PiHomeMmapScreenOther = __decorate([
    Component({
        components: {},
    })
], PiHomeMmapScreenOther);
export default PiHomeMmapScreenOther;
